<ng-template #toolbarRef>
  <div class="toolbar">
    <pdq-input background="light" placeholder="Search" [withIcon]="true" icon="search" [formControl]="searchControl">
    </pdq-input>
    <pdq-date-range-picker
      (onApply)="onDateRangeChange($event)"
      [createdAt]="shopCreated()"
      [defaultPreset]="defaultRange"
      [minDate]="90"
      [positionRight]="true"
      background="light">
    </pdq-date-range-picker>
  </div>
</ng-template>

<div class="table-outer">
  <pdq-tabs-group leftMargin="none" hideBorderBottom="true" (onChange)="onStatusTabChange($event)">
    @for (tab of statusTabs(); track tab.value) {
      <pdq-tab
        [label]="tab.label"
        [value]="tab.value"
        [active]="tab.value === 'all'"
        [loading]="countsLoading"></pdq-tab>
    }
  </pdq-tabs-group>
  <div class="table-stretch">
    <div class="table-inner">
      <pdq-data-table-v2 [rows]="rows()" [columns]="columns" [loading]="loading">
        <pdq-data-table-v2-column prop="orderName">
          <ng-template #cell let-row="row">
            <a class="order-link" [href]="getShopifyOrderUrl(row.orderId)" target="_blank" rel="noopener noreferrer">
              #{{ row.orderNumber }}
            </a>
          </ng-template>
        </pdq-data-table-v2-column>
        <pdq-data-table-v2-column prop="status">
          <ng-template #cell let-value let-row="row">
            <pdq-tag
              mode="rect"
              [value]="statusMap[row.status].label"
              [variant]="statusMap[row.status].variant"></pdq-tag>
          </ng-template>
        </pdq-data-table-v2-column>
      </pdq-data-table-v2>
    </div>
  </div>
  @if (counts()[activeStatusTab()] > pageSize()) {
    <div class="pagination-wrapper">
      <pdq-pagination
        mode="simple"
        [rangeLabel]="rangeLabel()"
        [hasNextPage]="pageInfo?.hasNextPage"
        [hasPreviousPage]="pageInfo?.hasPreviousPage"
        (onCursorPageChange)="onCursorPageChange($event)">
      </pdq-pagination>
    </div>
  }
</div>
